export const CONNECTED_APPS_PATH = `connected-apps`;
export const DIRECT_TRUST_PATH = `${CONNECTED_APPS_PATH}/direct-trust`;
export const EAS_PATH = `${CONNECTED_APPS_PATH}/external-authorization-servers`;
export const API_VERSION = '3.22';